import React, { useState } from "react";
import {
  CNavLink,
  CForm,
  CNavItem,
  CCollapse,
  CContainer,
  CHeaderToggler,
  CHeaderText,
  CHeader,
  CHeaderBrand,
  CHeaderDivider,
  CHeaderNav,
  CDropdown,
  CDropdownToggle,
  CDropdownMenu,
  CFormInput,
  CButton,
  CDropdownItem,
  CDropdownDivider,
} from "@coreui/react";

import logo from "../../assets/images/devai_logo.png";
import { HeaderCss } from "../../styles/header";
import CIcon from '@coreui/icons-react';
import { cilChevronBottom, cilChevronRight } from '@coreui/icons';

const Header = () => {
  const [visible, setVisible] = useState(false);
  return (
    <>
      <HeaderCss />
      <CHeader>
        <CContainer fluid>
          <CHeaderBrand href="/">
            <img src={logo} height={50} width={50} />{" "}
            <h1>
              Dev<b>AI</b>
            </h1>
          </CHeaderBrand>
          <CHeaderToggler onClick={() => setVisible(!visible)}>
          {!visible ? <CIcon icon={cilChevronBottom} size="xl"/> : <CIcon icon={cilChevronRight} size="xl"/>}
          </CHeaderToggler>
          <CCollapse className="header-collapse" visible={visible}>
            <CHeaderNav>
              <CNavItem>
                <CNavLink href="/" active>
                  Home
                </CNavLink>
              </CNavItem>
              <CNavItem>
                <CNavLink href="/dashboard">Dashboard</CNavLink>
              </CNavItem>
              <CNavItem>
                <CNavLink href="/community">Community</CNavLink>
              </CNavItem>
            </CHeaderNav>
          </CCollapse>
        </CContainer>
      </CHeader>
    </>
  );
};

export default Header;
